<template>
    <div class="bb-comment-item-user_name">
        <a href="javascript:"><strong>{{ user ? user.name : 'Guest' }}</strong></a>
    </div>
</template>

<script>
export default {
    name: "UserName",
    data() {
        return {
            hovered: false,
        }
    },
    methods: {
        parseDate() {
            const date = new Date(this.user.created_at);
            return `${date.getDate()}/${date.getMonth() > 10 ? date.getMonth() : '0' + date.getMonth()}/${date.getFullYear()}`
        }
    },
    props: {
        user: {
            type: Object,
            default: {}
        }
    }
}
</script>
